export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.$pinia.use((context) => {
        const storeId = context.store.$id;

        const serilizer = {
            serialize: JSON.stringify,
            deserialize: JSON.parse
        }

        if( process.client ) {
            const values = window.localStorage.getItem(storeId);

            let dataStorage = serilizer.deserialize(values);
            if(dataStorage) {
                context.store.$patch(dataStorage);
            }
        }
    })
});